import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import { pdf, Text, StyleSheet } from "@react-pdf/renderer";

import { SummaryDoc } from "./SummaryDoc";
import { DistributionDoc } from "./DistributionDoc";

const styles = StyleSheet.create({
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Roboto",
  },
  boldText: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
});

let zip = require("jszip")();
const JSZipUtils = require("jszip-utils");

export const ZipButton = (props) => {
  const [numComplete, setNumComplete] = useState(0);
  const [summaryReady, setSummaryReady] = useState(false);
  const [currentName, setCurrentName] = useState("none");

  //const [doneDoc, setDoneDoc] = useState(null);

  //when props change recreate summary
  useEffect(() => {
    if (currentName !== props.name) {
      setSummaryReady(false);
      //clear zip file
      zip.forEach(function (relativePath, file) {
        zip.remove(relativePath);
      });

      const name = props?.name?.toUpperCase();
      const batch = props?.batch?.toUpperCase();

      const batchIsName = batch.localeCompare(name) === 0;
      let fullName = batchIsName ? batch : batch + "-" + name;
      //then replace possible special characters in name with -
      fullName = fullName.replaceAll(/_|\.|:|\/| /g, "-");

      let parsedSummary = [];

      for (const [key, value] of Object.entries(props.summary)) {
        if (
          key.localeCompare("name") !== 0 &&
          key.localeCompare("date") !== 0 &&
          key.localeCompare("sourceMeds") !== 0 &&
          key.localeCompare("infoFields") !== 0 &&
          key.localeCompare("distData") !== 0 &&
          key.localeCompare("resultData") !== 0 &&
          key.localeCompare("ccURL") !== 0
        ) {
          let name = key.split(/(?=[A-Z])/);
          name[0] = name[0].charAt(0).toUpperCase() + name[0].slice(1);
          parsedSummary.push(
            <Text style={styles.text} key={key}>
              <Text style={styles.boldText}>{`${name.join(" ")}`}</Text>
              {`: ${value}`}
            </Text>
          );
        } else if (
          key.localeCompare("infoFields") === 0 ||
          key.localeCompare("resultData") === 0
        ) {
          //if info fields parse
          for (const [labelName, labelValue] of Object.entries(value)) {
            let name = labelName.split(/(?=[A-Z])/);
            name[0] = name[0].charAt(0).toUpperCase() + name[0].slice(1);
            parsedSummary.push(
              <Text style={styles.text} key={labelName}>
                <Text style={styles.boldText}>{`${name.join(" ")}`}</Text>
                {`: ${labelValue}`}
              </Text>
            );
          }
        }
      }

      // setDoneDoc(
      //   <SummaryDoc
      //     summary={parsedSummary}
      //     name={props.name}
      //     batch={props.batch}
      //     date={props.summary.date}
      //     sourceMeds={props.summary.sourceMeds}
      //   />
      //);
      console.log(typeof props.summary.sourceMeds);
      zip.file(
        `${fullName}-summary.pdf`,
        pdf(
          <SummaryDoc
            summary={parsedSummary}
            name={props.name}
            batch={props.batch}
            date={props.summary.date}
            sourceMeds={props.summary.sourceMeds}
          />
        ).toBlob()
      );

      //add dist pdf
      zip.file(
        `${fullName}-distribution-chain.pdf`,
        pdf(
          <DistributionDoc
            batchId={props.summary.batchId}
            mfrDate={props.summary.date}
            data={props.summary.distData}
            salesData={props.summary.salesData}
            title={true}
            notSM={props.notSM}
          />
        ).toBlob()
      );

      //add the pdfs from our DB
      const urls = props.urls;
      for (let i in urls) {
        const url = urls[i].url;
        const test = urls[i].name;
        let name = url.split("/");
        name = name[name.length - 1]; //name is end of url
        JSZipUtils.getBinaryContent(url, function (err, data) {
          if (err) {
            throw err; // or handle the error
          }
          console.log("got the data for: ", name);
          zip.file(`${fullName}-${test}.pdf`, data, { binary: true });
          setNumComplete((prevCount) => prevCount + 1);
        });
      }

      setSummaryReady(true);
      setCurrentName(props.name);
    }
  }, [
    props.batch,
    props.name,
    props.summary,
    props.urls,
    props.date,
    props.sourceMeds,
    currentName,
    props.notSM,
  ]);

  async function downloadZip() {
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(
        content,
        `${props.name.replaceAll(/_|\.|:|\/| /g, "-")}-test-results.zip`
      );
    });
  }

  return (
    // <PDFViewer width={1000} height={500}>
    //   {doneDoc}
    // </PDFViewer>
    <button
      onClick={() => downloadZip()}
      style={{ color: "white", margin: "8px", width: "225px" }}
      disabled={props.urls.length > numComplete || !summaryReady}
    >
      Download Zip
    </button>
  );
};
